import React from "react";
import Layout from "../../../components/Layout/Layout";

const Widget = () => {
  return <Layout>Widget</Layout>;
};

export default Widget;
